import { render, staticRenderFns } from "./ShippingMethod.vue?vue&type=template&id=48765979&scoped=true&lang=pug&"
import script from "./ShippingMethod.vue?vue&type=script&lang=js&"
export * from "./ShippingMethod.vue?vue&type=script&lang=js&"
import style0 from "./ShippingMethod.vue?vue&type=style&index=0&id=48765979&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48765979",
  null
  
)

export default component.exports